import { useLazyQuery } from "@apollo/client";
import CHECK_FOR_FILE from "queries/checkForFile";
import { useCallback } from "react";

export const useCheckForFile = (defaultKey?: string) => {
  const [checkForFile] = useLazyQuery(CHECK_FOR_FILE, {
    fetchPolicy: "network-only",
  });

  const fetchFile = useCallback(
    /**
     * `filename` names the download via the signed URL's Content-Disposition —
     * the only place a name can take effect, since browsers ignore the anchor
     * `download` attribute on cross-origin (S3) URLs. Omit it to fall back to
     * the S3 key's basename.
     */
    async (overrideKey?: string, filename?: string) => {
      const fileKey = overrideKey ?? defaultKey;
      if (!fileKey) {
        return undefined;
      }

      const { data } = await checkForFile({ variables: { key: fileKey, filename } });
      return data?.checkForFile?.signedUrl;
    },
    [defaultKey, checkForFile]
  );

  return { fetchFile };
};
